// REACT_APP_VERSION is $npm_package_version, expanded by react-scripts'
// dotenv-expand from package.json's "version" at build/dev time (see .env) —
// never hand-copy a version number here, it will drift the same way the
// previous hardcoded "web-0.1.0" already had.
// Sent as clientVersion so the server can enforce minSupportedClientVersion
// from GET /api/Voice/Vocabulary.
export const VOICE_CLIENT_VERSION = `web-${process.env.REACT_APP_VERSION ?? "0.0.0"}`;
